module.exports = __webpack_public_path__ + "img/itReport.766795ce.svg";